import React from 'react';
import {Node} from 'slate';
import {useSlate} from 'slate-react';

export const StatusBar = (): React.JSX.Element => {
  const slateEditor = useSlate();
  const pageCount = slateEditor.children.length;
  const currIndex = slateEditor.selection
    ? slateEditor.selection.anchor.path[0]
    : 0;
  const text = Node.string(slateEditor);

  return (
    <div
      className="status-bar"
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#f1f3f4',
        borderTop: '1px solid #dadce0',
        fontSize: '12px',
        color: '#5f6368',
        fontWeight: 500,
        userSelect: 'none',
        zIndex: 100,
        marginTop: 'auto'
      }}
    >
      <div>
        Page {Math.min(Math.max(1, currIndex + 1), pageCount)} of {pageCount}
      </div>
      <div>|</div>
      <div>
        {text.trim() === '' ? 0 : text.trim().split(/\s+/).length} words
      </div>
    </div>
  );
};
